import React from 'react';
import { ContainerMain } from './index.style';

const Container = ({ children }) => {
  return <ContainerMain>{children}</ContainerMain>;
};

export default Container;
